import React from 'react';

const howItWorksSteps = [
  {
    step: 'Call, Text, Email, or fill out the form at the bottom of the page:',
    instruction: 'Contact me by one of the methods above and we can go over what services will best suit your needs.'
  },
  {
    step: 'Schedule a walkthrough:',
    instruction: 'A walkthrough will be done to ensure to agreed apon items are removed. Images and or video can also be provided in the form below.'
  },
  {
    step: 'Free Estimate:',
    instruction: 'Once the walkthrough is done I will give you a free estimate.'
  },
  {
    step: 'Hauling and junk removal:',
    instruction: 'That\'s it super simple. I will come out and complete the service.'
  },
  {
    step: 'I can\'t wait to help',
    instruction: 'I look forward to hearing from you!'
  }
];

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="pt-24 bg-white text-black">
      <div className="container mx-auto px-4 py-8">
        <h2 className="text-4xl font-bold text-center mb-8" data-aos="fade-down">How It Works</h2>
        <div className="space-y-8">
          {howItWorksSteps.map((faq, index) => (
            <div key={index} className="p-4 bg-blue-100 rounded shadow" data-aos="fade-up" data-aos-delay={index * 100}>
              <h3 className="text-2xl font-semibold mb-2">{faq.step}</h3>
              <p>{faq.instruction}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;